import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
    currentDevice: state.rootReducer.currentDevice || "xl",
  };
}

class ProductCountdownTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initTimer = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const cssAlignment = generateStyle(payload, "alignment");
    const {
      timerTarget,
      timerDisplay,

      timerShape,
      timerSize,
      timerHour,
      timerMinute,
      timerSecond,
    } = payload.datas || { timerTarget: "-1", timerDisplay: null };

    let { timerBgColor, timerColor } = payload.datas || {};

    const settings =
      payload &&
      (payload["settings-" + this.props.currentDevice] || payload?.settings);

    if (settings?.timerBgColor) {
      timerBgColor = settings?.timerBgColor;
    }
    if (settings?.timerColor) {
      timerColor = settings?.timerColor;
    }
    return (
      <Container
        fluid={payload.fullContainer}
        style={cssSettings}
        className="countDownTimerBlock"
      >
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol" style={cssSettingsText}>
            {(timerDisplay && (
              <div
                className={`clockwrap ${timerSize || "medium"} ${
                  timerShape || "square"
                }`}
                style={cssAlignment}
              >
                {timerDisplay.hours && (
                  <div
                    className="clockbox"
                    style={{ backgroundColor: timerBgColor }}
                  >
                    <div style={{ color: timerColor }} className="value hours">
                      {(timerTarget === "-1" && 12) ||
                        (timerTarget === "static" && timerHour) ||
                        "00"}
                    </div>
                    <div style={{ color: timerColor }} className="label">
                      HOURS
                    </div>
                  </div>
                )}
                {timerDisplay.minutes && (
                  <div
                    className="clockbox"
                    style={{ backgroundColor: timerBgColor }}
                  >
                    <div
                      style={{ color: timerColor }}
                      className="value minutes"
                    >
                      {(timerTarget === "static" && timerMinute) || "00"}
                    </div>
                    <div style={{ color: timerColor }} className="label">
                      MINUTES
                    </div>
                  </div>
                )}
                {timerDisplay.seconds && (
                  <div
                    className="clockbox"
                    style={{ backgroundColor: timerBgColor }}
                  >
                    <div
                      style={{ color: timerColor }}
                      className="value seconds"
                    >
                      {(timerTarget === "static" && timerSecond) || "00"}
                    </div>
                    <div style={{ color: timerColor }} className="label">
                      SECONDS
                    </div>
                  </div>
                )}

                {!timerDisplay.hours &&
                  !timerDisplay.minutes &&
                  !timerDisplay.seconds && (
                    <div className="gk-error-message">
                      <p>No display selected</p>
                    </div>
                  )}
              </div>
            )) || (
              <div className="gk-error-message" style={cssAlignment}>
                <p>No display selected</p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initTimer()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initTimer()}
      </Draggable>
    );
  }
}

ProductCountdownTimer.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductCountdownTimer);
